<template>
	<div class="text-container">
		<div class="title">附件—第三方SDK说明</div>
		<div class="text" style="padding: 8px 0;" v-for="item in tableData">
			<div style="font-weight: bold;font-size: 18px;padding: 5px 0;">{{item.name}}</div>
			<div style="padding: 5px 0;"><span style="padding-right: 5px;font-weight: bold;font-size: 15px;">使用目的和场景: </span>{{item.use}}</div>
			<div style="padding: 5px 0;"><span style="padding-right: 5px;font-weight: bold;font-size: 15px;">收集个人信息的类型: </span>{{item.userType}}</div>
			<div style="padding: 5px 0;"><span style="padding-right: 5px;font-weight: bold;font-size: 15px;">第三方机构名称: </span>{{item.company}}</div>
			<div style="padding: 5px 0;"><span style="padding-right: 5px;font-weight: bold;font-size: 15px;">敏感权限: </span>{{item.permissions}}</div>
			<div style="padding: 5px 0;">
				<span style="padding-right: 5px;font-weight: bold;font-size: 15px;">第三方隐私政策链接: </span>
				<span v-if="item.url == '/'">{{item.url}}</span>
				<a v-else-if="!Array.isArray(item.url)" :href="item.url">{{item.url}}</a>
				<a v-else v-for="ite in item.url" style="padding-right: 10px;" :href="ite">{{ite}}</a>
			</div>
			<div style="padding: 5px 0;"><span style="padding-right: 5px;font-weight: bold;font-size: 15px;">信息收集方式: </span>{{item.collect}}</div>
			<div style="padding: 5px 0;color: #333;" v-if="item.tips" v-html="item.tips"></div>
		</div>
	</div>
</template>
	
<script>
import { mapState } from "vuex"
	export default {
		data() {
			return {};
		},
		mounted() {
			window.scrollTo(0, 0);
		},
		computed: {
			...mapState({
				tableData: "tableData"
			})
		}
	};
</script>

<style lang="less" scoped>
	.text-container {
		padding: 0 20px 50px;
		word-break:break-all;
		.title {
			font-size: 30px;
			margin: 15px 0;
			font-weight: bold;
			text-align: center;
		}
	}
</style>